import {TableComponent} from "../TableCheckComponent";
import {Paper} from "@mui/material";
import {Fragment} from "react";
import {VALUES_LEVELS} from "./LevelsComponent";


const columsDefault = [
        // { headerName: '#', field: 'id', flex: 0 },
        { headerName: 'Fecha de Creacion', field: 'fecha_creada', sortable: true, sort: 'desc'},
        { headerName: 'Unidad', field: 'unidad'},
        { headerName: 'Sucursal', field: 'sucursal'},
        { headerName: 'Posicion 1', field: 'P1'},
        { headerName: 'Milimetros 1', field: 'M1'},
        { headerName: 'Presión 1', field: 'presion_1'},
        { headerName: 'Posicion 2', field: 'P2'},
        { headerName: 'Milimetros 2', field: 'M2'},
        { headerName: 'Presión 2', field: 'presion_2'},
        { headerName: 'Posicion 3', field: 'P3'},
        { headerName: 'Milimetros 3', field: 'M3'},
        { headerName: 'Presión 3', field: 'presion_3'},
        { headerName: 'Posicion 4', field: 'P4'},
        { headerName: 'Milimetros 4', field: 'M4'},
        { headerName: 'Presión 4', field: 'presion_4'},
        { headerName: 'Posicion 5', field: 'P5'},
        { headerName: 'Milimetros 5', field: 'M5'},
        { headerName: 'Presión 5', field: 'presion_5'},
        { headerName: 'Posicion 6', field: 'P6'},
        { headerName: 'Milimetros 6', field: 'M6'},
        { headerName: 'Presión 6', field: 'presion_6'},
        { headerName: 'Aceite', field: 'aceite' , valueGetter: (params)=> VALUES_LEVELS.find(item => item.id === parseInt(params.data.aceite)).label},
        { headerName: 'Direccion', field: 'direccion', valueGetter: (params)=> VALUES_LEVELS.find(item => item.id === parseInt(params.data.direccion)).label},
        { headerName: 'Refrigerante', field: 'refrigerante', valueGetter: (params)=> VALUES_LEVELS.find(item => item.id === parseInt(params.data.refrigerante)).label},
        // { headerName: 'Clutch', field: 'clutch', valueGetter: (params)=> VALUES_LEVELS.find(item => item.id === parseInt(params.data.clutch)).label},
        { headerName: 'Reporte', field: 'reporte'},
 ];
export function UnitCheckComponent({dataCheck=[]}){


        return(
                <Fragment>

                    <Paper >

                            <TableComponent
                                columnsTable={columsDefault}
                                rowsTable={dataCheck}
                            />

                    </Paper>

                </Fragment>
        );
}